// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__jX4GE","label":"Avatar_label__9qhXn","icon":"Avatar_icon__kReKe zb-icon"};